export const STARS_GUIDED_RESOURCES_URL = 'https://coda.io/@shw/stars-guided-resources-document'

export const STARS_URL = 'https://starscollegenetwork.org/'
